import React, { useState } from 'react';
import './HubElementIcon.css';

type Size = 'sm' | 'lg';

type Props = {
  iconValue: string | null | undefined;
  size?: Size;
};

const PHOSPHOR_VERSION = '2.1.1';
const PHOSPHOR_CDN = (name: string) =>
  `https://unpkg.com/@phosphor-icons/core@${PHOSPHOR_VERSION}/assets/regular/${name}.svg`;

const isUrl = (value: string | null | undefined): boolean =>
  typeof value === 'string' &&
  (value.startsWith('http://') || value.startsWith('https://'));

// Strip optional `phosphor-` prefix so admins can paste the icon's name
// straight from https://phosphoricons.com/ without worrying about prefixing.
const normalizePhosphorName = (raw: string): string =>
  raw.startsWith('phosphor-') ? raw.slice('phosphor-'.length) : raw;

const HubElementIcon: React.FC<React.PropsWithChildren<Props>> = ({
  iconValue,
  size = 'lg',
}) => {
  const [errored, setErrored] = useState(false);

  if (!iconValue || errored) {
    return null;
  }

  const src = isUrl(iconValue)
    ? iconValue
    : PHOSPHOR_CDN(normalizePhosphorName(iconValue));

  return (
    <img
      src={src}
      alt=""
      className={`hub-element-icon hub-element-icon--${size}`}
      onError={() => setErrored(true)}
    />
  );
};

export default HubElementIcon;
